import type { ApiState, ExtendedFetchOptions } from '@/types/api-client'
import type {
	OnboardV2PayloadDto,
	OnboardV2ResponseDto,
	OnboardV2Step
} from '@/types/api-client/onboarding-v2'

type RequestFunction = <T>(
	endpoint: string,
	options?: ExtendedFetchOptions
) => Promise<T | null>

type CreateApiStateFunction = <T>(
	endpoint: string,
	options?: ExtendedFetchOptions
) => ApiState<T>

export function createOnboardingV2Api(
	request: RequestFunction,
	createApiState: CreateApiStateFunction
) {
	return {
		getOnboardingData: (accountId: string | number) => {
			const endpoint = `/V2/account/${accountId}/onboard`
			return request<OnboardV2ResponseDto>(endpoint, {
				method: 'GET',
				errorsAllowed: {
					titles: { 'Not Found': 'errors.onboarding.not_found' },
					messages: { 'Account not found': 'errors.onboarding.account_not_found' }
				}
			})
		},

		saveOnboardingStep: (
			accountId: string | number,
			step: OnboardV2Step,
			data: OnboardV2PayloadDto
		) => {
			const endpoint = `/V2/account/${accountId}/onboard/${step}`
			return request<OnboardV2ResponseDto>(endpoint, {
				method: 'POST',
				body: data,
				errorsAllowed: {
					titles: {
						'Bad Request': 'errors.onboarding.invalid_data',
						'Not Found': 'errors.onboarding.not_found',
						'Missing Prospect Conversion Data': 'errors.onboarding.missing_prospect_data'
					},
					messages: {
						'Invalid step': 'errors.onboarding.invalid_step',
						'Validation failed': 'errors.onboarding.validation_failed'
					}
				}
			})
		},

		createOnboardingState: (accountId: string | number) => {
			const endpoint = `/V2/account/${accountId}/onboard`
			return createApiState<OnboardV2ResponseDto>(endpoint, {
				method: 'GET',
				errorsAllowed: {
					titles: { 'Not Found': 'errors.onboarding.not_found' },
					messages: { 'Account not found': 'errors.onboarding.account_not_found' }
				}
			})
		}
	}
}
